import { common, Portals } from '@qwyk/models';
import { LocationCodePipe, VolumeDimensionsPipe } from '@qwyk/ui-standalone';

export function mapFormToQuotationPayload(
    formValue: any,
    isLclOrLse: boolean,
    dimensionsInput: boolean,
    locationCodePipe: LocationCodePipe,
    volumeDimensionsPipe: VolumeDimensionsPipe
): Portals.QuotationRequest {
    let packages = formValue.packages;

    if (isLclOrLse) {
        if (dimensionsInput) {
            packages = packages.map((e: any) => {
                e.unit_volume = volumeDimensionsPipe.transform(
                    e.unit_length,
                    'dimensionsToVolume',
                    e.uom
                );
                return e;
            });
        } else {
            packages = packages.map((e: any) => {
                const dim = volumeDimensionsPipe.transform(
                    e.unit_volume,
                    'volumeToDimensions',
                    e.uom
                );
                e.unit_length = dim;
                e.unit_width = dim;
                e.unit_height = dim;
                return e;
            });
        }
    }

    let originCode = formValue.header.origin.locode;
    let originName = formValue.header.origin.display_name;
    let originLatitude = null;
    let originLongitude = null;
    if (formValue.header.origin_type === common.LocationType.PLACE) {
        originCode = locationCodePipe.transform(formValue.header.origin_address);
        originName = formValue.header.origin_address.formattedAddress;
        originLatitude = formValue.header.origin_address.position?.lat;
        originLongitude = formValue.header.origin_address.position?.lng;
    }

    let destinationCode = formValue.header.destination.locode;
    let destinationName = formValue.header.destination.display_name;
    let destinationLatitude = null;
    let destinationLongitude = null;
    if (formValue.header.destination_type === common.LocationType.PLACE) {
        destinationCode = locationCodePipe.transform(
            formValue.header.destination_address
        );
        destinationName = formValue.header.destination_address.formattedAddress;
        destinationLatitude = formValue.header.destination_address.position?.lat;
        destinationLongitude = formValue.header.destination_address.position?.lng;
    }

    return {
        owner_reference: formValue.owner_reference,
        transport_mode: formValue.header.transport_mode,
        origin: {
            type: formValue.header.origin_type,
            code: originCode,
            locode: formValue.header.origin.locode,
            name: originName,
            country_code: formValue.header.origin.country_code,
            latitude: originLatitude,
            longitude: originLongitude,
        },
        destination: {
            type: formValue.header.destination_type,
            code: destinationCode,
            locode: formValue.header.destination.locode,
            name: destinationName,
            country_code: formValue.header.destination.country_code,
            latitude: destinationLatitude,
            longitude: destinationLongitude,
        },
        require_origin_charges:
            formValue.header.origin_type === common.LocationType.PLACE ||
            formValue.header.require_origin_charges,
        require_freight_charges: formValue.header.require_freight_charges,
        require_destination_charges:
            formValue.header.destination_type === common.LocationType.PLACE ||
            formValue.header.require_destination_charges,
        commodity: formValue.commodity,
        inco_term: formValue.inco_term,
        cargo_ready: formValue.cargo_ready,
        currency: formValue.currency,
        packages: packages.map((e: any) => {
            e.id = 0;
            return e;
        }),
        additionals: formValue.additionals,
        is_network_quotation: formValue.header.is_network_quotation,
        organization_network_authorizations_id: formValue.header
            .is_network_quotation
            ? formValue.header.organization_network_authorizations_id
            : null,
        include_own_rates: formValue.header.is_network_quotation
            ? formValue.header.include_own_rates
            : null,
    } as any; // Using type assertion to any here because the payload we are constructing has more fields than QuotationRequest allows
}
